require('./commands/command.js');
require('./commands/add_row.js');
require('./commands/change_row_color.js');
require('./commands/change_palette.js');
require('./commands/clear_rows.js');
require('./commands/clone_column.js');
require('./commands/copy_row.js');
require('./commands/delete_block.js');
require('./commands/delete_column.js');
require('./commands/delete_row.js');
require('./commands/edit_block.js');
require('./commands/edit_body_image.js');
require('./commands/edit_block_region_image.js');
require('./commands/edit_footer.js');
require('./commands/edit_view_online.js');
require('./commands/mirror_row.js');
require('./commands/move_column.js');
require('./commands/move_row.js');
require('./commands/rotate_row.js');
require('./commands/change_template_width.js');
